import { Mail, MapPin, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { LogoFull } from "./Logo";

const IMG =
  "https://images.unsplash.com/photo-1753194931716-1add84f0b6ae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBmbG9yaWRhJTIwaG9tZSUyMGV4dGVyaW9yJTIwcG9vbHxlbnwwfHx8fDE3OTA0NDc5MDF8MA&ixlib=rb-4.1.0&q=85";

export const Footer = ({ onBook }) => (
  <footer id="contact" className="relative bg-deep text-sand overflow-hidden noise">
    <div className="absolute inset-0 blueprint-grid" />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8 pt-24 pb-10">
      <div className="relative rounded-2xl overflow-hidden border border-sand/10 mb-20">
        <img src={IMG} alt="Florida pool home at dusk" loading="lazy" className="w-full h-64 sm:h-80 object-cover" />
        <div className="absolute inset-0 bg-obsidian/60" />
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
          <h2 className="font-display font-black text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight max-w-2xl">
            Your closing date won't wait. <span className="text-terra">Neither should you.</span>
          </h2>
          <button
            data-testid="footer-book-button"
            onClick={() => onBook()}
            className="mt-8 bg-sun text-obsidian font-semibold px-8 py-4 rounded-full transition-transform duration-300 hover:scale-105 active:scale-95"
          >
            Schedule Your Inspection
          </button>
        </div>
      </div>

      <div className="grid md:grid-cols-[1.4fr_1fr_1fr] gap-12 pb-16 border-b border-sand/10">
        <div>
          <LogoFull />
          <p className="mt-5 text-sand/50 text-sm leading-relaxed max-w-sm">
            Independent, licensed &amp; insured Florida home inspections. Precision
            reports for buyers, owners, and insurers — delivered same-day.
          </p>
        </div>
        <div>
          <div className="font-mono text-[10px] tracking-[0.25em] text-sun uppercase mb-5">Contact</div>
          <div className="space-y-3.5 text-sm">
            <a href="tel:3059868602" data-testid="footer-phone" className="flex items-center gap-3 text-sand/70 hover:text-terra transition-colors">
              <Phone size={15} className="text-terra" /> (305) 986-8602
            </a>
            <a href="mailto:safepointinspections01@gmail.com" data-testid="footer-email" className="flex items-center gap-3 text-sand/70 hover:text-terra transition-colors">
              <Mail size={15} className="text-terra" /> safepointinspections01@gmail.com
            </a>
            <div className="flex items-start gap-3 text-sand/70">
              <MapPin size={15} className="text-terra mt-0.5" />
              <span className="flex flex-col gap-1.5">
                <Link to="/locations/miami" data-testid="footer-location-miami" className="hover:text-sun transition-colors">
                  Miami
                </Link>
                <Link to="/locations/fort-lauderdale" data-testid="footer-location-fort-lauderdale" className="hover:text-sun transition-colors">
                  Fort Lauderdale
                </Link>
                <Link to="/locations/west-palm-beach" data-testid="footer-location-west-palm-beach" className="hover:text-sun transition-colors">
                  West Palm Beach
                </Link>
                <span>Greater South Florida</span>
              </span>
            </div>
          </div>
        </div>
        <div>
          <div className="font-mono text-[10px] tracking-[0.25em] text-sun uppercase mb-5">Credentials</div>
          <div className="space-y-3 text-sm text-sand/70">
            <div>
              FL Home Inspector License{" "}
              <a
                href="https://www.myfloridalicense.com/wl11.asp"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-license-verify-link"
                className="text-sand font-semibold hover:text-sun transition-colors underline-offset-4 hover:underline"
              >
                #HI19148 ↗
              </a>
            </div>
            <div>
              <a
                href="/license-hi19148.pdf"
                download
                data-testid="footer-license-download"
                className="text-sand/70 hover:text-sun transition-colors underline-offset-4 hover:underline"
              >
                DBPR License Document ↓
              </a>
            </div>
            <div>
              <a
                href="/proof-of-insurance.pdf"
                download
                data-testid="footer-insurance-download"
                className="text-sand/70 hover:text-sun transition-colors underline-offset-4 hover:underline"
              >
                General Liability &amp; E&amp;O Insured ↓
              </a>
            </div>
            <div>InterNACHI Standards of Practice</div>
            <div>Citizens-Approved Report Forms</div>
          </div>
        </div>
      </div>

      <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-3">
        <span className="font-mono text-[10px] tracking-[0.2em] text-sand/30 uppercase">
          © {new Date().getFullYear()} Safe Point Inspections LLC
        </span>
        <span className="font-mono text-[10px] tracking-[0.2em] text-sand/30 uppercase">
          Precision · Protection · Peace of Mind
        </span>
      </div>
    </div>
  </footer>
);
